// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line[data-v-46c6da7d]{display:flex;flex-grow:1;position:relative;top:50%;transform:perspective(1px) translateY(-50%)}.text[data-v-46c6da7d]{font-size:2.25rem;font-weight:700;letter-spacing:.025em;margin-left:1.25rem;margin-right:1.25rem;text-align:center}a[data-v-46c6da7d]{-webkit-text-decoration:none!important;text-decoration:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
